import {ajax,getRequestUrl,formatData} from "../request";

export default {
  // 礼物信息查询
  findGiftList(data, method) {
    return ajax('post', getRequestUrl('/gift/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 礼物信息详情
  findGiftInfo(data, method) {
    return ajax('post', getRequestUrl('/api/Gift/findGiftInfo'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 礼物信息保存
  saveGiftData(data, method) {
    return ajax('post', getRequestUrl('/gift/save'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 礼物上下架
  findGiftIsOn(data, method) {
    return ajax('post', getRequestUrl('/gift/setOn'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 礼物模块--设置区域礼物
  setRegionGift(data, method) {
    return ajax('post', getRequestUrl('/gift/setGiftRegion'), data, {
      method,
    });
  },

  // 礼物模块--删除区域礼物
  deleteRegionGift(data, method) {
    return ajax('post', getRequestUrl('/gift/deleteRegionGift'), data, {
      method,
    });
  },

  // 礼物模块--批量下架礼物区域
  setOffRegionGift(data, method) {
    return ajax('post', getRequestUrl('/gift/setOffRegionGift'), data, {
      method,
    });
  },

  // 表情管理列表
  findExpressionList(data, method) {
    return ajax('post', getRequestUrl('/emoji/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 表情信息详情
  findExpressionInfo(data, method) {
    return ajax('post', getRequestUrl('/api/Gift/findExpressionInfo'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 表情上下架
  findExpressionIsOn(data, method) {
    return ajax('post', getRequestUrl('/emoji/setOn'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 表情保存
  saveExpressionData(data, method) {
    return ajax('post', getRequestUrl('/emoji/save'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 活动礼物栏列表
  activityGiftList(data, method) {
    return ajax('post', getRequestUrl('/api/Gift/activityGiftList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 活动礼物信息保存
  activityGiftSave(data, method) {
    return ajax('post', getRequestUrl('/api/Gift/activityGiftSave'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // ID定制礼物列表
  celebrityGiftApplyList(data, method) {
    return ajax('post', getRequestUrl('/api/Gift/celebrityGiftApplyList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 审核ID定制礼物申请
  celebrityGiftApplyCheck(data, method) {
    return ajax('post', getRequestUrl('/api/Gift/celebrityGiftApplyCheck'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 审核ID定制礼物批量下架
  celebrityGiftRemovalList(data, method) {
    return ajax('post', getRequestUrl('/api/Gift/celebrityGiftRemovalList'), data, {
      method,
    });
  },

  // 新表情管理-表情库列表
  emojiList(data, method) {
    return ajax('post', getRequestUrl('/emoji_new/emoji/list'), data, {
      method,
    });
  },

  // 新表情管理-新增/编辑 表情库表情
  emojiSave(data, method) {
    return ajax('post', getRequestUrl('/emoji_new/emoji/save'), data, {
      method,
    });
  },

  // 新表情管理-表情库 设置/下架分栏
  emojiSet(data, method) {
    return ajax('post', getRequestUrl('/emoji_new/emoji/bindPkg'), data, {
      method,
    });
  },

  // 新表情管理-表情分栏列表，不分页
  emojiPackageList(data, method) {
    return ajax('post', getRequestUrl('/emoji_new/emojiPackage/list'), data, {
      method,
    });
  },

  // 新表情管理-表情库 设置/下架分栏
  emojiPackageSet(data, method) {
    return ajax('post', getRequestUrl('/emoji_new/emojiPackage/setOn'), data, {
      method,
    });
  },

  // 新表情管理-新增/编辑 表情分栏
  emojiPackageSave(data, method) {
    return ajax('post', getRequestUrl('/emoji_new/emojiPackage/save'), data, {
      method,
    });
  },

  // 新表情管理-复制 表情分栏
  emojiPackageCopy(data, method) {
    return ajax('post', getRequestUrl('/emoji_new/emojiPackage/copy'), data, {
      method,
    });
  },

  // 新表情管理-表情分栏详情列表（区域管理用）
  emojiPackageDetailList(data, method) {
    return ajax('post', getRequestUrl('/emoji_new/emojiPackageDetail/list'), data, {
      method,
    });
  },

  // 新表情管理-批量删除表情分栏详情项
  emojiPackageDel(data, method) {
    return ajax('post', getRequestUrl('/emoji_new/emojiPackageDetail/batchDeleteEmoji'), data, {
      method,
    });
  },


// 火箭配置-数值配置
  rocketConfigList(data, method) {
    return ajax('post', getRequestUrl('/rocket/config'), data, {
      method,
    })
  },
// 火箭配置-编辑数值配置
  rocketConfigSave(data, method) {
    return ajax('post', getRequestUrl('/rocket/config/save'), data, {
      method,
    })
  },
// 火箭配置-奖励配置列表
  rocketRewardList(data, method) {
    return ajax('post', getRequestUrl('/rocket/reward/list'), data, {
      method,
    })
  },
// 火箭配置-删除 奖励配置
  rocketRewardDelete(data, method) {
    return ajax('post', getRequestUrl('/rocket/reward/delete'), data, {
      method,
    })
  },


  // 火箭配置-检查 奖励配置
  rocketRewardCheckID(data, method) {
    return ajax('post', getRequestUrl('/rocket/reward/check'), data, {
      method,
    });
  },

  // 火箭配置-新增/编辑 奖励配置
  rocketRewardSave(data, method) {
    return ajax('post', getRequestUrl('/rocket/reward/save'), data, {
      method,
    });
  },

  // 火箭配置-新增/编辑 奖励配置 - 推送
  rocketRewardPush(data, method) {
    return ajax('post', getRequestUrl('/rocket/reward/push'), data, {
      method,
    });
  },

    // 关系信物 列表
  relationshipTokenList(data, method) {
    return ajax('post', getRequestUrl('/relationship_token/list'), data, {
      method,
    });
  },
      // 关系信物 保存
  relationshipTokenSave(data, method) {
    return ajax('post', getRequestUrl('/relationship_token/save'), data, {
      method,
    });
  },
}




// WEBPACK FOOTER //
// ./src/js/https/gift.js